"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COMMODITY_BROKER = exports.STOCK_BROKER = exports.SINGLE_ASSET_REAL_ESTATE = exports.HEALTH_CARE_BUSINESS = void 0;
exports.HEALTH_CARE_BUSINESS = "health_care_business";
exports.SINGLE_ASSET_REAL_ESTATE = "single_asset_real_estate";
exports.STOCK_BROKER = "stock_broker";
exports.COMMODITY_BROKER = "commodity_broker";